var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Roadie H logo 00BBBB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Roadie-H-logo-00BBBB",
    fillRule: "nonzero",
    className: "icon-fill"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.66,0 C22.6008458,0.00584091794 0.522881589,21.6658976 0,48.72 L29.52,48.72 L29.52,27.4 C29.5172793,27.208223 29.5922623,27.0235032 29.7278827,26.8878827 C29.8635032,26.7522623 30.048223,26.6772793 30.24,26.68 L52.29,26.68 C72.99,26.68 71.36,41.1 71.36,41.1 C71.36,49.47 66.04,53.17 58.92,53.17 L0.11,53.17 C0.11,53.72 0.18,54.27 0.24,54.82 L56.88,54.82 C58.7851203,54.8685697 60.580331,55.7225667 61.82,57.17 L62.29,57.82 L62.29,57.82 L73.83,73.82 L59.13,73.82 C58.6874075,73.8013798 58.2780158,73.580087 58.02,73.22 L49.11,59.78 C48.9915844,59.5806327 48.8542869,59.3931044 48.7,59.22 L43.29,59.22 C43.0173822,59.3361252 42.8403238,59.6036802 42.84,59.9 L42.84,73.04 C42.8427207,73.231777 42.7677377,73.4164968 42.6321173,73.5521173 C42.4964968,73.6877377 42.311777,73.7627207 42.12,73.76 L30.29,73.76 C30.098223,73.7627207 29.9135032,73.6877377 29.7778827,73.5521173 C29.6422623,73.4164968 29.5672793,73.231777 29.57,73.04 L29.57,59.22 L0.9,59.22 C5.93028802,84.9279445 30.0574534,102.312921 56.0359691,98.9485594 C82.0144848,95.584198 100.917068,72.6266311 99.2325987,46.4853846 C97.5481297,20.3441381 75.8554614,0.00241595179 49.66,-7.10542736e-15 L49.66,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.67,48.72 C56.21,48.72 58.83,46.52 58.83,43.01 L58.83,42.87 C58.83,39.09 56.08,37.16 51.61,37.16 L43.61,37.16 C43.418223,37.1572793 43.2335032,37.2322623 43.0978827,37.3678827 C42.9622623,37.5035032 42.8872793,37.688223 42.89,37.88 L42.89,48 C42.8872793,48.191777 42.9622623,48.3764968 43.0978827,48.5121173 C43.2335032,48.6477377 43.418223,48.7227207 43.61,48.72 L51.67,48.72 Z",
    id: "Path"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCircle);
export default __webpack_public_path__ + "static/media/logo-circle.560b2578.svg";
export { ForwardRef as ReactComponent };